module.exports = __webpack_public_path__ + "static/media/usersActive.9413adff.svg";